import { Component, OnInit } from '@angular/core';
import { AccordionEvent } from 'src/app/shared/accordion/accordion.event';

@Component({
  selector: 'app-accordion-item-content',
  templateUrl: './accordion-item-content.component.html',
  styleUrls: ['./accordion-item-content.component.scss']
})
export class AccordionItemContentComponent extends AccordionEvent implements OnInit {

  constructor() { super(); }

  ngOnInit() {
  }

}
